import { render } from "./FormRelManyProperties.vue?vue&type=template&id=7ab3fef2"
import script from "./FormRelManyProperties.vue?vue&type=script&lang=js"
export * from "./FormRelManyProperties.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/FormRelManyProperties.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ab3fef2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ab3fef2', __exports__)) {
    console.log('reload')
    api.reload('7ab3fef2', __exports__)
  }
  
  module.hot.accept("./FormRelManyProperties.vue?vue&type=template&id=7ab3fef2", () => {
    console.log('re-render')
    api.rerender('7ab3fef2', render)
  })

}


export default __exports__